export const offerSalesTabs = {
  data: () => ({
    offersTypeTabHighLevel: 0,
    offersTypeTabLowLevel: 0,
    offerSalesKeyNames: {
      offer_sales: 'offer_sales',
      percentage_offer_sales: 'percentage_offer_sales',
      dynamic_pricing_percentage_offer_sales: 'dynamic_pricing_percentage_offer_sales',
      takepay_offer_sales: 'takepay_offer_sales',
      combo_offer_sales: 'combo_offer_sales',
      target_products: 'target_products',
      cashback_percentage_offer_sales: 'cashback_percentage_offer_sales',
      cashback_absolute_offer_sales: 'cashback_absolute_offer_sales',
      points_offer_sales: 'points_offer_sales',
      next_buy_cashback_offer_sales: 'next_buy_cashback_offer_sales',
    },
  }),
  computed: {
    hasGeneralOfferMetrics() {
      const hasNonNullValue = (obj) => {
        if (!obj) return false
        for (const key in obj) {
          if (key !== '__typename') {
            if (obj[key] !== null && obj[key] !== undefined && !Array.isArray(obj[key])) {
              if (typeof obj[key] === 'object' && hasNonNullValue(obj[key])) {
                return true
              }
            }
            if (typeof obj[key] === 'object' && hasNonNullValue(obj[key])) {
              return true
            }
          }
        }
        return false
      }
      return hasNonNullValue(this.campanha?.campaignMetrics?.general)
    },
    currentOfferTypeKeyName() {
      const keys = [
        [
          ...(this.hasGeneralOfferMetrics || this.campanha.offer_sales?.length ? [this.offerSalesKeyNames.offer_sales] : []),
          ...(this.campanha?.campaignMetrics?.percentage || this.campanha.percentage_offer_sales?.length
            ? [this.offerSalesKeyNames.percentage_offer_sales]
            : []),
          ...(this.campanha?.campaignMetrics?.dynamic_pricing_percentage || this.campanha.dynamic_pricing_percentage_offer_sales?.length
            ? [this.offerSalesKeyNames.dynamic_pricing_percentage_offer_sales]
            : []),
          ...(this.campanha?.campaignMetrics?.takepay || this.campanha.takepay_offer_sales?.length ? [this.offerSalesKeyNames.takepay_offer_sales] : []),
          ...(this.campanha?.campaignMetrics?.combo || this.campanha.combo_offer_sales?.length ? [this.offerSalesKeyNames.combo_offer_sales] : []),
        ],
        [
          ...(this.campanha?.campaignMetrics?.cashback_percentage || this.campanha.cashback_percentage_offer_sales?.length
            ? [this.offerSalesKeyNames.cashback_percentage_offer_sales]
            : []),
          ...(this.campanha?.campaignMetrics?.cashback_absolute || this.campanha.cashback_absolute_offer_sales?.length
            ? [this.offerSalesKeyNames.cashback_absolute_offer_sales]
            : []),
          ...(this.campanha?.campaignMetrics?.points || this.campanha.points_offer_sales?.length ? [this.offerSalesKeyNames.points_offer_sales] : []),
          ...(this.campanha?.campaignMetrics?.nextbuycashback || this.campanha.next_buy_cashback_offer_sales?.length
            ? [this.offerSalesKeyNames.next_buy_cashback_offer_sales]
            : []),
        ],
      ]
      if ((this.hasCashbackOrPoints && !this.hasOffers) || this.offersTypeTabHighLevel === 1) {
        return keys[1][this.offersTypeTabLowLevel]
      } else {
        return keys[0][this.offersTypeTabLowLevel]
      }
    },
    isCashbackCurrentOfferType() {
      return [this.offerSalesKeyNames.cashback_percentage_offer_sales, this.offerSalesKeyNames.cashback_absolute_offer_sales].includes(
        this.currentOfferTypeKeyName
      )
    },
    isNextBuyCashbackCurrentOfferType() {
      return this.offerSalesKeyNames.next_buy_cashback_offer_sales === this.currentOfferTypeKeyName
    },
    isPointsCurrentOfferType() {
      return this.offerSalesKeyNames.points_offer_sales === this.currentOfferTypeKeyName
    },
    isCashbackOrPointsCurrentOfferType() {
      return this.isCashbackCurrentOfferType || this.isPointsCurrentOfferType
    },
    getSubTabTabs() {
      return this.offersTypeResultsTabs.filter((tab) => tab.highLevel === this.offersTypeTabHighLevel)
    },
    hasOffers() {
      return Boolean(
        this.campanha?.offer_sales?.length > 0 ||
          this.campanha?.percentage_offer_sales?.length > 0 ||
          this.campanha?.dynamic_pricing_percentage_offer_sales?.length > 0 ||
          this.campanha?.takepay_offer_sales?.length > 0 ||
          this.campanha?.combo_offer_sales?.length > 0 ||
          this.hasGeneralOfferMetrics ||
          this.campanha?.campaignMetrics?.percentage ||
          this.campanha?.campaignMetrics?.dynamic_pricing_percentage ||
          this.campanha?.campaignMetrics?.takepay ||
          this.campanha?.campaignMetrics?.combo
      )
    },
    hasCashbackOrPoints() {
      return Boolean(
        this.campanha?.cashback_percentage_offer_sales?.length > 0 ||
          this.campanha?.cashback_absolute_offer_sales?.length > 0 ||
          this.campanha?.points_offer_sales?.length > 0 ||
          this.campanha?.next_buy_cashback_offer_sales?.length > 0 ||
          this.campanha?.campaignMetrics?.cashback_percentage ||
          this.campanha?.campaignMetrics?.cashback_absolute ||
          this.campanha?.campaignMetrics?.points ||
          this.campanha?.campaignMetrics?.nextbuycashback
      )
    },
    offersTypeTabsHighLevel() {
      const offersTypeTabsHighLevel = []

      if (this.hasOffers) {
        offersTypeTabsHighLevel.push({
          name: 'Descontos e ofertas',
          icon: 'sell',
        })
      }

      if (this.hasCashbackOrPoints) {
        offersTypeTabsHighLevel.push({
          name: 'Cashback e pontos',
          icon: 'currency_exchange',
        })
      }

      return offersTypeTabsHighLevel
    },
    offersTypeResultsTabs() {
      const offersTypeResultsTabs = []

      if (this.hasGeneralOfferMetrics || this.campanha?.offer_sales?.length) {
        offersTypeResultsTabs.push({
          name: 'Desconto absoluto',
          offerSalesKeyName: this.offerSalesKeyNames.offer_sales,
          highLevel: 0,
          tabIndex: 0,
          haveLength: false,
          keyName: 'offer_sales',
        })
      }

      if (this.campanha?.campaignMetrics?.percentage || this.campanha?.percentage_offer_sales?.length) {
        offersTypeResultsTabs.push({
          name: 'Desconto percentual',
          offerSalesKeyName: this.offerSalesKeyNames.percentage_offer_sales,
          highLevel: 0,
          tabIndex: 1,
          haveLength: false,
          keyName: 'percentage_offer_sales',
        })
      }

      if (this.campanha?.campaignMetrics?.dynamic_pricing_percentage || this.campanha?.dynamic_pricing_percentage_offer_sales?.length) {
        offersTypeResultsTabs.push({
          name: 'Desconto percentual por loja',
          offerSalesKeyName: this.offerSalesKeyNames.dynamic_pricing_percentage_offer_sales,
          highLevel: 0,
          tabIndex: 1,
          haveLength: false,
          keyName: 'dynamic_pricing_percentage_offer_sales',
        })
      }

      if (this.campanha?.campaignMetrics?.takepay || this.campanha?.takepay_offer_sales?.length) {
        offersTypeResultsTabs.push({
          name: 'Leve e pague',
          highLevel: 0,
          tabIndex: 2,
          haveLength: false,
          keyName: 'takepay_offer_sales',
        })
      }

      if (this.campanha?.campaignMetrics?.combo || this.campanha?.combo_offer_sales?.length) {
        offersTypeResultsTabs.push({
          name: 'Combo',
          highLevel: 0,
          tabIndex: 3,
          haveLength: false,
          keyName: 'combo_offer_sales',
        })
      }

      if (this.campanha?.campaignMetrics?.cashback_percentage || this.campanha?.cashback_percentage_offer_sales?.length) {
        offersTypeResultsTabs.push({
          name: 'Cashback percentual',
          offerSalesKeyName: this.offerSalesKeyNames.cashback_percentage_offer_sales,
          highLevel: this.hasCashbackOrPoints && !this.hasOffers ? 0 : 1,
          tabIndex: 4,
          keyName: 'cashback_percentage_offer_sales',
        })
      }

      if (this.campanha?.campaignMetrics?.cashback_absolute || this.campanha?.cashback_absolute_offer_sales?.length) {
        offersTypeResultsTabs.push({
          name: 'Cashback absoluto',
          offerSalesKeyName: this.offerSalesKeyNames.cashback_absolute_offer_sales,
          highLevel: this.hasCashbackOrPoints && !this.hasOffers ? 0 : 1,
          tabIndex: 5,
          keyName: 'cashback_absolute_offer_sales',
        })
      }

      if (this.campanha?.campaignMetrics?.points || this.campanha?.points_offer_sales?.length) {
        offersTypeResultsTabs.push({
          name: 'Pontos',
          offerSalesKeyName: this.offerSalesKeyNames.points_offer_sales,
          highLevel: this.hasCashbackOrPoints && !this.hasOffers ? 0 : 1,
          tabIndex: 6,
          keyName: 'points_offer_sales',
        })
      }

      if (this.campanha?.campaignMetrics?.nextbuycashback || this.campanha?.next_buy_cashback_offer_sales?.length) {
        offersTypeResultsTabs.push({
          name: 'Cashback',
          offerSalesKeyName: this.offerSalesKeyNames.next_buy_cashback_offer_sales,
          highLevel: this.hasCashbackOrPoints && !this.hasOffers ? 0 : 1,
          tabIndex: 7,
          keyName: 'next_buy_cashback_offer_sales',
        })
      }

      return offersTypeResultsTabs
    },
    offerTypeResultsCurrentTabDetails() {
      return this.offersTypeResultsTabs.find((offer) => offer.keyName === this.currentOfferTypeKeyName)
    },
  },
}
